export default "__VITE_ASSET__x9W8tTja__"